
import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpEvent, HttpHandler, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, retry } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { LoaderService } from './loader.service';
import { environment } from 'src/environments/environment';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  readonly FLIGHT_GUEST_TOKEN = `h%3y87_4yd$jasn^d$d3nbdc@nb0nma`;
  readonly HOTEL_GUEST_TOKEN = 'Bearer AisBqnVeUykYXqmoVClyJ-Yb6NlwtRIh';

  constructor(private injector: Injector, public loaderService: LoaderService, private util: UtilityService) { }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.isLoading.next(true);
    let headers = new HttpHeaders({
      ...this.setAuthTokens(req.url),
    });
    const clone = req.clone({ headers: headers });
    return next.handle(clone).pipe(
      // retry(1),
      catchError(this.handleError),
      finalize(() => {
        this.loaderService.isLoading.next(false)
      })
    )
  }

  setAuthTokens(url: string) {
    let tokenObject: any = {
      'Authorization': this.HOTEL_GUEST_TOKEN,
    };
    if (url.includes(environment.flightConfig.apiUrl)) {
      const authService = this.injector.get(AuthService);
      const FLIGHTLOGINWITHOUTLOGIN = localStorage.getItem('FlightLoginToken');
      const authToken = authService.loggedIn ? localStorage.getItem('Auth_Key') : FLIGHTLOGINWITHOUTLOGIN;
    
      tokenObject = {
        Authorization: FLIGHTLOGINWITHOUTLOGIN || authToken || this.FLIGHT_GUEST_TOKEN,
      };
    }
    if (url.includes('pg/bookingApi/apipayment')) {
      Object.assign(tokenObject,{'Content-Type': 'application/x-www-form-urlencoded'})
    }
    if (url.includes('b2c/booking/payment')) {
      Object.assign(tokenObject,{'Content-Type': 'application/x-www-form-urlencoded'})
    }
    if (url.includes('auth/refresh-token')) {
      const authToken = localStorage.getItem('Auth_Key');
      tokenObject = {
        'Authorization': authToken,
      }
    }
    return tokenObject;
  }
}